// Lib
import { prop, propIn } from '../../../../../../../../common/utils/immutableHelper';

export const getViewer = prop('viewer');
export const getViewerId = propIn(['viewer', '_id']);
